/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { AutoForm } from '../../common/auto-form';
import { APV_SELECT_FIELDS } from './fields';
import { APVSelectResultView } from './result-view';
import {
  APVSelectFormValues,
  apvSelectDefaults,
  apvSelectSchema,
} from './schema';
import { PRODUCT, buildAPVSelectPayload, simulateAPVSelect } from './service';

export function APVSelectPage() {
  const [lastRequest, setLastRequest] = useState<unknown>(null);

  const mutation = useMutation({
    mutationFn: (values: APVSelectFormValues) => simulateAPVSelect({ values }),
  });

  const hasResult = mutation.isSuccess || mutation.isError;

  return (
    <>
      <div className="card">
        <div className="card-body">
          <AutoForm
            fields={APV_SELECT_FIELDS}
            schema={apvSelectSchema}
            defaults={apvSelectDefaults}
            isLoading={mutation.isLoading}
            expectedProduct={PRODUCT}
            onSubmit={(values) => {
              const payload = {
                product: PRODUCT, ...buildAPVSelectPayload(values), debug: true,
              };
              setLastRequest(payload);
              mutation.mutate(values);
            }}
          />
        </div>
      </div>

      {hasResult && (
        <APVSelectResultView
          request={lastRequest}
          response={mutation.data}
          error={mutation.isError ? mutation.error : undefined}
        />
      )}
    </>
  );
}
